import { QueryClient } from '@tanstack/react-query';

/** 앱 단일 QueryClient — 로그아웃 시 clear() 로 사용자별 캐시 누출 차단. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: false, refetchOnWindowFocus: false },
  },
});
